import { apiService, handleResponse } from '@/services/apiService';
import type { OrderInterface } from './type';

export class OrderRepository {
    async getToPrepareOrders(data: { page: number, perPage: number, parentId?: number | null }) {
        const response = await apiService.post(`/v1/orders/to-prepare`, data);
        return handleResponse(response);
    }

    async getRetiredOrders(data: { page: number, perPage: number, parentId?: number | null }) {
        const response = await apiService.post(`/v1/orders/retired`, data);
        return handleResponse(response);
    }
    async processPickup(id: number, payload: { products: Record<number, number>, big_bags: Record<number, number> }) {
        const response = await apiService.post(`/v1/orders/${id}/pickup`, payload);
        return handleResponse(response);
    }
    async processReady(id: number) {
        const response = await apiService.post(`/v1/orders/${id}/ready`);
        return handleResponse(response);
    }

    async cancelOrder(id: number, payload: { cancellation_reason: string, custom_comment?: string }) {
        const response = await apiService.post(`/v1/orders/${id}/cancel`, payload);
        return handleResponse(response);
    }

    async getOrder(id: number) {
        const response = await apiService.get(`/v1/orders/${id}`);
        return handleResponse(response);
    }

    async syncProduct(data: { product_id: number, quantity: number, action: 'add' | 'remove' }) {
        const response = await apiService.post('/v1/orders/sync-product', data);
        return handleResponse(response);
    }

    async syncBigBag(data: { big_bag_id: number, quantity: number, action: 'add' | 'remove' }) {
        const response = await apiService.post('/v1/orders/sync-big-bag', data);
        return handleResponse(response);
    }

    async getDeliverySettings() {
        const response = await apiService.get('/v1/delivery-settings');
        return handleResponse(response);
    }

    async validateOrder(amount: number, currency: string = 'eur', order: OrderInterface, construction_site: string) {
        const response = await apiService.post(`/v1/orders/validate`, {
            amount: Math.round(amount * 100),
            currency,
            order: order,
            construction_site
        });
        return handleResponse(response);
    }

    async validateStorekeeperOrder(amount: number, currency: string = 'eur', order: OrderInterface, construction_site: string, company_id?: number, user_id?: number, comment?: string, email?: string) {
        const response = await apiService.post(`/v1/orders/validate/storekeeper`, {
            amount: Math.round(amount * 100),
            currency,
            order: order,
            construction_site,
            company_id,
            user_id,
            comment,
            email
        });
        return handleResponse(response);
    }

    async fetchCartTotals(payload: any) {
        const response = await apiService.post(`/v1/orders/calculate`, payload);
        return handleResponse(response);
    }
}
